export default __webpack_public_path__ + "static/codeplatform-ai-2-1e0c7045a88b55f959e8b4aa5669ec26.png";